// state
export default {
  // 您的小区
  communities: [],
  // 各商圈
  businesses: [],
  // 各区县
  counties: [],
  // 小区状态
  communityStatus: '',
  // 商圈状态
  businessStatus: '',
  // 县区状态
  countyStatus: '',
  // 微信状态
  wxReady: false
}



// WEBPACK FOOTER //
// ./src/store/state.js